import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import StyledArrowLink from './arrowLink.style';

const ArrowLink = React.forwardRef(
  (
    {
      title = '',
      href,
      size = '40',
      className = '',
      shortArrow = false,
      stretched = false,
      srTitle = '',
      ariaLabel = '',
      ariaLabelledby = '',
      onClick = () => {}
    },
    ref
  ) => {
    const t = useTranslations();

    if (!href) return null;

    return (
      <StyledArrowLink ref={ref}>
        <Link
          href={href}
          aria-label={ariaLabel || ''}
          aria-labelledby={ariaLabelledby || ''}
          className={className}
          onClick={onClick}
        >
          {stretched && <span className="stretched__link" />}
          {title && <span>{title}</span>}
          {srTitle && !title && <span className="sr-only">{srTitle}</span>}
          {!srTitle && !title && <span className="sr-only">{t('learnMore')}</span>}
          {shortArrow ? (
            <svg
              role="img"
              aria-label={srTitle || t('learnMore')}
              focusable="false"
              width={size}
              height={size}
              viewBox="0 0 58 58"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M46.8122 15.1715C46.5812 14.9428 46.1652 14.9428 45.8872 15.1715L44.0392 17.0466C43.7622 17.2752 43.7622 17.6868 44.0392 17.9612L52.1291 25.9188C52.5451 26.3295 52.2221 27.0621 51.6201 27.0621H0.647989C0.277995 27.0621 0 27.3365 0 27.7015V30.3092C0 30.6751 0.277995 30.9495 0.647989 30.9495H51.6191C52.2211 30.9495 52.5441 31.6355 52.1281 32.0471L44.0382 40.0504C43.8072 40.2781 43.8072 40.6906 44.0382 40.965L45.8882 42.7944C45.9487 42.859 46.0232 42.9107 46.1069 42.9462C46.1905 42.9817 46.2813 43 46.3732 43C46.4651 43 46.5559 42.9817 46.6395 42.9462C46.7232 42.9107 46.7977 42.859 46.8582 42.7944L57.029 32.7331C57.629 32.0928 58 31.2687 58 30.3997V27.6109C58 26.742 57.63 25.9188 57.03 25.2776L46.8112 15.1724L46.8122 15.1715Z"
                fill="currentColor"
              />
            </svg>
          ) : (
            <svg
              role="img"
              aria-label={srTitle || t('learnMore')}
              focusable="false"
              width={size}
              height={size}
              viewBox="0 0 58 58"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M49.3249 18.1347C49.1455 17.9551 48.8228 17.9551 48.6078 18.1347L47.174 19.608C46.959 19.7875 46.959 20.111 47.174 20.3271L53.447 26.5791C53.7697 26.9025 53.5191 27.4773 53.0526 27.4773L0.502146 27.4773C0.215477 27.4773 0 27.6929 0 27.9802L0 30.0288C0 30.3161 0.215477 30.5318 0.502146 30.5318L53.0526 30.5318C53.5191 30.5318 53.7697 31.0709 53.447 31.3943L47.174 37.6824C46.9945 37.8619 46.9945 38.1854 47.174 38.401L48.6078 39.8383C48.8228 40.0539 49.1455 40.0539 49.3605 39.8383L57.2473 31.9334C57.7129 31.4299 58 30.783 58 30.1005V27.9085C58 27.226 57.7129 26.5791 57.2473 26.0761L49.3249 18.1347Z"
                fill="currentColor"
              />
            </svg>
          )}
        </Link>
      </StyledArrowLink>
    );
  }
);

ArrowLink.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string,
  srTitle: PropTypes.string,
  ariaLabelledby: PropTypes.string,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  shortArrow: PropTypes.bool,
  stretched: PropTypes.bool,
  hoverEffect: PropTypes.bool,
  onClick: PropTypes.func
};

ArrowLink.displayName = 'ArrowLink';
export default ArrowLink;
